import {
	type FieldPath,
	type FieldValues,
	type UseControllerProps,
	useController,
} from "react-hook-form";
import type { RadioCardOption } from "../../patterns/radio-select";
import { RadioCardSelectInput } from "../inputs/RadioCardSelectInput";

export type FormRadioCardSelectProps<
	TFieldValues extends FieldValues,
	TValue extends string | number | boolean = string,
	TTransformedValues = TFieldValues,
> = UseControllerProps<TFieldValues, FieldPath<TFieldValues>, TTransformedValues> & {
	options: RadioCardOption<TValue>[];
	direction?: "row" | "column";
	gap?: "sm" | "md" | "lg";
	errorMessage?: string;
	className?: string;
	testId?: string;
};

export const FormRadioCardSelect = <
	TFieldValues extends FieldValues,
	TValue extends string | number | boolean = string,
	TTransformedValues = TFieldValues,
>({
	control,
	defaultValue,
	disabled,
	name,
	options,
	direction,
	gap,
	errorMessage,
	className,
	testId,
}: FormRadioCardSelectProps<TFieldValues, TValue, TTransformedValues>) => {
	const {
		field,
		fieldState: { error },
	} = useController<TFieldValues, FieldPath<TFieldValues>, TTransformedValues>({
		name,
		control,
		defaultValue,
		disabled,
	});

	return (
		<RadioCardSelectInput<TValue>
			value={field.value}
			onChange={field.onChange}
			onBlur={field.onBlur}
			options={options}
			direction={direction}
			gap={gap}
			error={error}
			errorMessage={errorMessage}
			disabled={disabled}
			className={className}
			testId={testId}
		/>
	);
};
